import { useState, useEffect } from "react";
import { searchInField } from "../modules/api/search";
import {
  userClientDb,
  uiLanguage,
} from "../modules/auth/selectors/userSelector";
import { useSelector } from "react-redux";
import axios, { Canceler } from "axios";

function useSearchFetching(
  fil: string,
  pageNumber: number,
  module: string,
  field: string,
  fieldValues?: { [key: string]: any },
) {
  const clientDb = useSelector(userClientDb);
  const locale = useSelector(uiLanguage);
  const top = 30;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [options, setOptions] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setOptions([]);
  }, [fil]);

  useEffect(() => {
    setLoading(true);
    setError(undefined);
    let cancel: Canceler;

    const query = {
      clientDbId: clientDb ? clientDb.id : 0,
      module: module,
      field: field,
      pageNumber: pageNumber,
      fil: fil,
      locale: locale,
      top: top,
      isList: 1,
      fieldValues
    };

    const config = {
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    };

    searchInField(query, config)
      .then(({ data }) => {
        setOptions((prevData: any[]) => {
          return [...prevData, ...data];
        });
        setLoading(false);
        setHasMore(data.length > 0 && data[0].pageNumber > pageNumber);
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        setError(err);
      });

    return () => cancel();
  }, [fil, pageNumber, clientDb]);

  return { loading, error, options, hasMore };
}

export default useSearchFetching;
